// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3gFiX","Success":"Button_Success__2Rka1","Danger":"Button_Danger__2ogZq","Alternative":"Button_Alternative__3COp7"};